import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from '@app/app.module';
import { environment } from '@environments/environment';
import { licenseKey } from '@root/devextreme-license';
import config from 'devextreme/core/config';
import themes from 'devextreme/ui/themes';

config({
  licenseKey,
});

themes.initialized(() => {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowser()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.error(err));
});
